<template>
    <div class="slider slider--image"
    >
        <div class="swiper-container slider__container" ref="slider">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
        </div>

        <div class="slider__controls">
            <div class="slider__nav">
                <button class="slider__nav-btn slider__nav-btn--prev" ref="prev">
                    <z-icon
                        name="btn-arrow"
                        width="16"
                        height="16"
                    />
                </button>
                <button class="slider__nav-btn slider__nav-btn--next" ref="next">
                    <z-icon
                        name="btn-arrow"
                        width="16"
                        height="16"
                    />
                </button>
            </div>
        </div>
        <div class="slider__pagination"></div>
    </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.min.css'

export default {
    name: 'slider',
    props: {
        slidesPerView: String,
        spaceBetween: Number,
        theme: String
    },
    data () {
        return {
            slider: undefined,
            isEnd: false
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            let options = {
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: this.$refs.prev,
                    nextEl: this.$refs.next
                },
                pagination: {
                    clickable: true,
                    bulletClass: 'slider__pagination-bullet',
                    bulletActiveClass: 'slider__pagination-bullet--active',
                    el: '.slider__pagination'
                }
            }

            if (this.slidesPerView) {
                options.slidesPerView = this.slidesPerView

                options.breakpoints = {
                    600: {
                        slidesPerView: 1
                    },
                    1359: {
                        slidesPerView: 2
                    }
                }
            }

            if (this.spaceBetween) {
                options.spaceBetween = this.spaceBetween
            }

            this.slider = new Swiper(this.$refs.slider, options)
        }
    }
}
</script>

<style lang="scss">
.slider--image {
    .slider {
        &__controls {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: absolute;
            bottom: 0;
            z-index: 2;
            left: 0;
            margin: 0;
            padding: $token-spacers-m;

            @include breakpoint(v-tablet) {
                display: none;
            }
        }

        &__nav {
            display: flex;
            margin: 0;

            &-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                width: 64px;
                height: 64px;
                margin-right: $token-spacers-xs;
                background-color: $token-colors-white;
                border: 1px solid $token-colors-black-20;
                border-radius: 50%;
                outline: none;
                cursor: pointer;
                transform: rotate(45deg);
                transition: border $transition, transform 0.1s linear;

                &:last-child {
                    margin-right: 0;
                }

                &:hover {
                    border: 4px solid;
                    border-left-color: $token-colors-primary;
                    border-top-color: $token-colors-primary;
                    border-right-color: #FBB92F;
                    border-bottom-color: #E42213;
                }

                &.swiper-button-disabled {
                    opacity: 0.3;
                    pointer-events: none;
                }

                &--prev {
                    .z-icon {
                        transform: rotate(-45deg) scale(-1, 1);
                    }
                }

                &--next {
                    .z-icon {
                        transform: rotate(-45deg);
                    }
                }

                @include breakpoint (v-tablet) {
                    width: 48px;
                    height: 48px;

                    .z-icon {
                        width: 12px !important;
                        height: 12px !important;
                    }
                }

                @include breakpoint (v-tablet) {
                    width: 40px;
                    height: 40px;
                }
            }
        }

        &__pagination {
            display: none;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            margin: -12px;

        @include breakpoint(v-tablet) {
            display: flex;
        }

        &-bullet {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 13px;
            height: 13px;
            cursor: pointer;
            background-color: $token-colors-white;
            border: 1px solid $token-colors-black-10;
            border-radius: 50%;
            outline: 0;
            padding: 0 6px;
            margin: 34px 4px 0;
            transition: background-color $transition, border-color $transition;

            &:hover:not(.slider--image__pagination-bullet--active),
            &:focus:not(.slider--image__pagination-bullet--active) {
                background-color: #F1F1F1;
                border-color: #F1F1F1;
            }

            &:active,
            &--active {
                background-color: $token-colors-primary;
                border-color: $token-colors-primary;
                width: 16px;
                height: 16px;
            }
        }
    }
    }
}
</style>
